// Design tokens — single source of truth cho lms-frontend.
// Soft & modern palette; build trên nền react-bootstrap.
// Khi cần dùng trong styled-components: import { tokens } from 'design-system';
// Khi cần dùng inline trong react-bootstrap: ưu tiên className theo
// Bootstrap utility, fallback inline style cho property chưa map sẵn.

export const colors = {
  // Brand
  primary: '#2563eb',
  primaryHover: '#1d4ed8',
  primaryActive: '#1e40af',
  primarySoft: '#eff6ff',

  // Status
  success: '#16a34a',
  successSoft: '#dcfce7',
  danger: '#dc2626',
  dangerSoft: '#fee2e2',
  warning: '#d97706',
  warningSoft: '#fef3c7',
  info: '#0891b2',
  infoSoft: '#cffafe',

  // Neutral (gray scale)
  white: '#ffffff',
  gray50: '#f8fafc',
  gray100: '#f1f5f9',
  gray200: '#e2e8f0',
  gray300: '#cbd5e1',
  gray400: '#94a3b8',
  gray500: '#64748b',
  gray600: '#475569',
  gray700: '#334155',
  gray800: '#1e293b',
  gray900: '#0f172a',

  // Surfaces
  background: '#f8fafc',
  surface: '#ffffff',
  surfaceMuted: '#f1f5f9',
  border: '#e2e8f0',
  borderHover: '#cbd5e1',
};

// 4-base scale. Đánh số theo bước 4px để dễ nhớ và liên kết với
// Bootstrap utility (mb-1 = 0.25rem = 4px).
export const spacing = {
  0: '0',
  1: '4px',
  2: '8px',
  3: '12px',
  4: '16px',
  5: '20px',
  6: '24px',
  8: '32px',
  10: '40px',
  12: '48px',
  16: '64px',
};

export const radius = {
  none: '0',
  sm: '6px',
  md: '10px',
  lg: '14px',
  xl: '20px',
  pill: '999px',
};

export const shadow = {
  none: 'none',
  sm: '0 1px 2px rgba(15, 23, 42, 0.06), 0 1px 3px rgba(15, 23, 42, 0.04)',
  md: '0 4px 12px rgba(15, 23, 42, 0.08), 0 2px 4px rgba(15, 23, 42, 0.04)',
  lg: '0 12px 32px rgba(15, 23, 42, 0.10), 0 4px 8px rgba(15, 23, 42, 0.04)',
  focus: '0 0 0 3px rgba(37, 99, 235, 0.20)',
};

export const typography = {
  fontFamily: "system-ui, -apple-system, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif",
  size: {
    xs: '12px',
    sm: '13px',
    base: '14px',
    md: '15px',
    lg: '17px',
    xl: '20px',
    h3: '24px',
    h2: '28px',
    h1: '32px',
  },
  weight: {
    regular: 400,
    medium: 500,
    semibold: 600,
    bold: 700,
  },
  leading: {
    tight: 1.25,
    normal: 1.5,
    relaxed: 1.65,
  },
};

export const transition = {
  fast: 'all 0.15s ease',
  base: 'all 0.2s ease',
  slow: 'all 0.3s cubic-bezier(.4, 0, .2, 1)',
};

export const tokens = {
  colors,
  spacing,
  radius,
  shadow,
  typography,
  transition,
};

export default tokens;
